












import { Component, Mixins, Prop } from 'vue-property-decorator'
import CoresDoPainel from './CoresDoPainel'
import { textoDoAniversario } from '@/shareds/painel-do-cliente-shareds'

@Component
export default class EtiquetaDeAniversario extends Mixins(CoresDoPainel) {
	@Prop({ type: String, default: null }) dataDeNascimento!: string | null

	get texto() {
		return textoDoAniversario(this.dataDeNascimento)
	}
}
